
import { defineComponent } from 'vue';
import { telefoneLink } from '@/uteis/conteudo';

export default defineComponent({
    name: 'BarraAcaoMobile',
    emits: ['abrir-chat'],
    computed: {
        telefoneHref(): string { return telefoneLink(); }
    }
});
